import { Flex, Box, chakra } from '@chakra-ui/react';
import { Search, Filter } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onFilterClick?: () => void;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Explore public events...',
  onFilterClick,
}: SearchBarProps) {
  return (
    <Flex align="center" justify="center" gap={{ base: '2', sm: '3' }} mb="5" w="full">
      <Flex
        flex="1"
        position="relative"
        align="center"
        bg="volyx.lightGray"
        borderRadius="20px"
        px="4"
        minH="12"
        maxW={{ base: 'calc(100% - 40px - 8px)', sm: 'none' }}
      >
        <Box as={Search} boxSize="20px" color="volyx.textSecondary" flexShrink={0} mr="3" aria-hidden />
        <chakra.input
          type="search"
          id="organizations-search"
          name="search"
          flex="1"
          border="none"
          bg="transparent"
          fontSize="md"
          fontFamily="body"
          color="volyx.text"
          outline="none"
          minW="0"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          _placeholder={{ color: 'volyx.textSecondary' }}
          placeholder={placeholder}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          autoComplete="off"
        />
      </Flex>
      {onFilterClick && (
        <chakra.button
          display="flex"
          alignItems="center"
          gap="2"
          px={{ base: '0', sm: '4' }}
          minH="12"
          h="12"
          bg="volyx.primary"
          color="white"
          border="none"
          borderRadius="20px"
          fontSize="sm"
          fontWeight="semibold"
          fontFamily="body"
          cursor="pointer"
          transition="opacity 0.2s"
          _hover={{ opacity: 0.9 }}
          _focus={{ outline: 'none', boxShadow: '0 0 0 2px #1F2932' }}
          w={{ base: '12', sm: 'auto' }}
          minW={{ base: '12', sm: 'auto' }}
          maxW={{ base: '12', sm: 'none' }}
          justifyContent={{ base: 'center', sm: 'flex-start' }}
          flexShrink={{ base: 0, sm: 1 }}
          onClick={onFilterClick}
          aria-label="Filter"
        >
          <Box as="span" whiteSpace="nowrap" display={{ base: 'none', sm: 'inline' }}>
            Filter
          </Box>
          <Box as={Filter} boxSize="16px" flexShrink={0} />
        </chakra.button>
      )}
    </Flex>
  );
}
